import { Toast as BaseToast } from "@base-ui/react/toast"

export const toastManager = BaseToast.createToastManager()

export const useToast = (): Toast.UseToast => {
  const toast = BaseToast.useToastManager()

  const add: Toast.UseToast["add"] = (options) => {
    const id = toast.add(options)
    return id
  }

  const remove: Toast.UseToast["remove"] = (id) => {
    toast.close(id)
  }

  const update: Toast.UseToast["update"] = (id, options) => {
    toast.update(id, options)
  }

  const promise: Toast.UseToast["promise"] = (promiseValue, options) => {
    return toast.promise(promiseValue, options)
  }

  const toasts = toast.toasts.filter(
    (toast): toast is Toast => toast.type !== undefined && types.includes(toast.type)
  )

  return {
    toasts,
    add,
    remove,
    update,
    promise
  }
}

const types = ["default", "success", "error", "info", "loading"]

export interface Toast {
  id: Toast.Id
  type: Toast.Type
  title: Toast.Title
  description?: Toast.Description
  action?: (toast: Toast) => React.ReactNode
}

export namespace Toast {
  export type Id = string
  export type Type = "default" | "success" | "error" | "info" | "loading"
  export type Title = string
  export type Description = string
  export type ActionProps = {
    children: React.ReactNode
    onClick?: () => void
  }

  type ToastOptions = Pick<Toast, "title" | "description" | "action">

  export interface UseToast {
    add: (options: Omit<Toast, "id">) => Id
    toasts: Array<Toast>
    remove: (id: Id) => void
    update: (id: Id, options: Partial<Toast>) => void
    promise: <T>(
      promiseValue: Promise<T>,
      options: {
        loading: ToastOptions
        success: (result: T) => ToastOptions
        error: (error: unknown) => ToastOptions
      }
    ) => Promise<T>
  }
}
